<template>
  <view class="radio-group-inline-demo">
    <view class="cube-radio-group-example">
      <cube-radio-group
        options="{{ options }}"
        inline="{{ true }}"
        wx:model="{{ checkedValue }}"
        wx:model-prop="value"
      ></cube-radio-group>
    </view>
    <view class="view-desc">selected value: {{ checkedValue }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      options: [
        {
          value: 'Option1',
          text: 'Option1'
        },
        {
          value: 'Option2',
          text: 'Option2'
        },
        {
          value: 'Option3',
          text: 'Option3'
        }
      ],
      checkedValue: ''
    }
  })
</script>

<style lang="stylus">
.radio-group-inline-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "view-desc": "../../components/desc/index",
    "cube-radio-group": "@mpxjs/mpx-cube-ui/src/components/radio-group/index"
  }
}
</script>
